import { useResources } from '@pressreader/resources';

interface Props {
    type: 'small' | 'large';
}

export function Spinner(props: Props) {
    const { localizedString } = useResources();

    const className = `pr-spinner ${props.type === 'small' ? 'pr-spinner-s' : 'pr-spinner-l'}`;
    return (
        <div className={className}>
            <div className="spinner" role="status" aria-live="polite" aria-label={localizedString('Loading.Text', 'Loading...')}>
                <div className="spinner-line line1"></div>
                <div className="spinner-line line2"></div>
                <div className="spinner-line line3"></div>
                <div className="spinner-line line4"></div>
                <div className="spinner-line line5"></div>
                <div className="spinner-line line6"></div>
                <div className="spinner-line line7"></div>
                <div className="spinner-line line8"></div>
                <div className="spinner-line line9"></div>
                <div className="spinner-line line10"></div>
                <div className="spinner-line line11"></div>
            </div>
        </div>
    );
}
